import React, { useState } from 'react';
import { searchIcons, CourseIcon } from './iconLibrary';

// Сетка иконок с поиском для обложки курса.
const IconPicker = ({ value, onChange }) => {
  const [q, setQ] = useState('');
  const list = searchIcons(q);

  return (
    <div className="ip">
      <div className="ip-search">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Поиск иконки… (напр. книга, атом, звезда)" />
        {q && <button className="ip-clear" onClick={() => setQ('')} aria-label="Очистить">×</button>}
      </div>
      <div className="ip-grid">
        {list.map(ic => (
          <button key={ic.key} type="button" title={ic.name}
            className={`ip-cell${value === ic.key ? ' on' : ''}`}
            onClick={() => onChange && onChange(ic.key)}>
            <CourseIcon icon={ic.key} size={22} sw={1.7} />
          </button>
        ))}
        {list.length === 0 && <div className="ip-empty">Ничего не найдено</div>}
      </div>
    </div>
  );
};

export default IconPicker;
